import { ButtonsTheme } from '../types';
import { colors } from '../constants/colors';
import { typography } from '../constants/typography';

//TODO: fix disabled colors
export const button: ButtonsTheme = {
  primary: {
    active: {
      border: `2px solid ${colors.jlMoneyGreenDark}`,
      text: colors.jlMoneyGreenDark,
      bg: colors.jlMoneyGreenLight,
      opacity: '1',
    },
    disabled: {
      border: `2px solid ${colors.jlMoneyGreyLightest}`,
      bg: colors.jlMoneyGreyLightest,
      text: colors.jlMoneyGreyLight,
    },
    focus: {
      boxShadow: `0 0 0 2px ${colors.white}, 0 0 0 4px ${colors.jlMoneyBlue}`,
      border: `2px solid ${colors.jlMoneyGreenDark}`,
    },
    hover: {
      border: `2px solid ${colors.jlMoneyGreenDark}`,
      text: colors.jlMoneyGreenDark,
      bg: colors.white,
    },
    border: `2px solid ${colors.jlMoneyGreenDark}`,
    text: colors.jlMoneyGreenNeon,
    bg: colors.jlMoneyGreenDark,
  },
  secondary: {
    active: {
      border: `2px solid ${colors.jlMoneyGreenDark}`,
      text: colors.jlMoneyGreenDark,
      bg: colors.jlMoneyGreenLight,
      opacity: '1',
    },
    disabled: {
      border: `2px solid ${colors.jlMoneyGreyLightest}`,
      bg: colors.jlMoneyGreyLightest,
      text: colors.jlMoneyGreyLight,
    },
    focus: {
      boxShadow: `0 0 0 2px ${colors.white}, 0 0 0 4px ${colors.jlMoneyBlue}`,
      border: `2px solid ${colors.jlMoneyGreenDark}`,
    },
    hover: {
      border: `2px solid ${colors.jlMoneyGreenDark}`,
      text: colors.jlMoneyGreenDark,
      bg: colors.jlMoneyBeige,
    },
    border: `2px solid ${colors.jlMoneyGreenDark}`,
    text: colors.jlMoneyGreenDark,
    bg: colors.white,
  },
  // styling=link is not used in rezza or quopa, confirm styling with design if start using
  link: {
    focus: {
      boxShadow: `0 0 0 2px ${colors.white}, 0 0 0 4px ${colors.jlMoneyBlue}`,
      border: `2px solid transparent`,
    },
    hover: {
      border: `2px solid ${colors.jlMoneyGreenDark}`,
      text: colors.jlMoneyGreenDark,
      bg: colors.white,
    },
    border: `2px solid transparent`,
    text: colors.greyDarkest,
    bg: 'transparent',
  },
  text: {
    weight: typography?.weights.semiBold,
    height: typography.lineHeight.lead,
    size: typography.text.sizes.lead,
  },
  borderRadius: `6px`,
  padding: '8px 16px',
};
